import * as React from "react";

const fields = (t) => {return {
    config: {columns: 1},
    fields: [

        {
            name: "name",
            label: t ? t("common.name") : "Nazwa",
            column: 1,
            hideForReadOnly: true
        }, {
            name: "contactWithProduct",
            label: t ? t("common.contact_with_product") : "Kontakt z produktem",
            defaultEnabled: true,
            type: "boolean",
            column: 1,
        },
        {
            name: "installationNumber",
            label: t ? t("common.installation_number") : "Numer instalacyjny",
            column: 1,
        },
        {
            name: "comment",
            label: t ? t("common.comments") : "Uwagi",
            column: 1,
        },
        {
            name: "files",
            label: t ? t("common.photos") : "Zdjęcia",
            column: 1,
            type: "file"
        },
    ]


}};

export default fields;